export default {
      id: "icon-check-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-check",
      toString: function () {
        return this.url;
      }
    }